import {StreamJSONItemBase} from "PDFLib/core/writers/JSONWriter/JSONItem/Streams/StreamJSONItemBase";
import PDFStream from "PDFLib/core/objects/PDFStream";
import {encodeToBase64} from "PDFLib/utils";

export class RawJSONItem extends StreamJSONItemBase
{
    public Base64String:any;


    constructor(stream: PDFStream) {
        super(stream);
        this.Base64String=encodeToBase64(stream.getContents());
    }

    GetType() {
        return 'SR';
    }

}